import { AiSdk } from "./AiSdk";

const ai = new AiSdk();
window["ai"] = ai;
window["AiSdkReady"] = true;
window.dispatchEvent(new Event("AiSdkReady"));
